<template>
    <v-modal name="appSharePage" :width="300" height="auto" :pivotY="0.1" :click-to-close="true" class="modal"
        @before-open="beforeOpen">
        <div class="text">
            <span v-if="notice">{{ notice }}</span>
            <div class="input-wrapper">
                <v-input class="input" :value="shareUrl" readonly />
            </div>
        </div>
        <div class="buttons">
            <button class="g-button" @click.prevent="$modal.hide('appSharePage')">
                {{ $t('CANCEL') }}
            </button>
            <button class="g-button g-button_primary" @click.prevent="copy">
                {{ $t('COPY') }}
            </button>
        </div>
    </v-modal>
</template>

<script>
import copyToClipboard from 'copy-text-to-clipboard';
import VModal from '@/components/VModal.vue';
import VInput from '@/components/VInput.vue';

export default {
  components: {
    VModal,
    VInput,
  },
  data() {
    return {
      shareUrl: '',
      notice: '',
      styleElement: null,
    };
  },
  methods: {
    beforeOpen(event) {
      if (event.params) {
        this.shareUrl = event.params.customUrl || '';
        this.notice = event.params.notice || '';
      }

      // Inject global style before opening the modal
      this.injectModalStyle();
    },
    injectModalStyle() {
      // Remove any existing style element
      if (this.styleElement) {
        document.head.removeChild(this.styleElement);
      }

      // Create a new style element
      this.styleElement = document.createElement('style');
      this.styleElement.innerHTML = `
                .vm--modal[name="appSharePage"] {
                    background-color: var(--bg) !important;
                    border: 2px solid var(--lighter-primary) !important;
                    box-shadow: none !important;
                    border-radius: 0 !important;
                }
            `;

      // Add it to document head
      document.head.appendChild(this.styleElement);
    },
    copy() {
      const isCopied = copyToClipboard(this.shareUrl);
      if (isCopied) {
        this.$notify({
          type: 'success',
          text: this.$t('SHARE_LINK_COPIED'),
        });
        this.$modal.hide('appSharePage');
        return;
      }

      this.$notify({
        type: 'error',
        text: this.$t('SOMETHING_WENT_WRONG'),
      });
    },
  },
  beforeDestroy() {
    // Clean up style element when component is destroyed
    if (this.styleElement) {
      document.head.removeChild(this.styleElement);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.modal {
    &::v-deep {
        .vm--modal {
            background-color: var(--bg);
            border: 2px solid var(--lighter-primary);
        }

        .vm--overlay {
            background: rgba(0, 0, 0, var(--modal-overlay-opacity));
        }
    }
}

.text {
    padding: 15px 15px 10px;
    white-space: pre-line;
}

.input-wrapper {
    margin-top: 10px;
}

.buttons {
    display: flex;
    padding: 10px 15px 15px;
    border-top: 1px solid var(--tertiary-accent);

    button:last-child {
        margin-left: auto;
    }
}

.input {
    width: 100%;
}
</style>
